export default __webpack_public_path__ + "static/media/material-ui-1.0e0f630d.svg";